export default __webpack_public_path__ + "static/funders-css-910ea841ba501ab6c00f0f2a44702e60.png";